import { z } from "zod";

/// URL search params for the employee's own `/leave` page.
///
/// `tab` is ACCEPTED AND IGNORED. The page used to be a balance row above a
/// tab strip; it is now four stacked sections and there is no tab to select.
/// The key stays in the schema because this object is `.strict()`, so removing
/// it would make every bookmark and shared link carrying the old
/// `?tab=requests` fail validation rather than land on the page it names. It
/// costs one line to keep and breaks somebody's saved link to drop.
/// `period` is a `LeavePeriod` id, and the page falls back rather than errors
/// when it names one the reader cannot see (`selectPeriod`). It is here so the
/// leave year survives a refresh, a back button and a link somebody pastes to a
/// colleague, all of which are how people actually return to a past year.
///
/// Not validated against the real ids, which only the server knows: an unknown
/// id is a fallback and not a broken page.
export const leaveRouteSearchSchema = z
  .object({
    tab: z.enum(["requests"]).optional(),
    period: z.string().optional(),
  })
  .strict();

export type LeaveRouteSearch = z.infer<typeof leaveRouteSearchSchema>;
